import Icon from "./IconDialogClose.svg?react";
import styled from "@emotion/styled";

export const IconDialogClose = styled(Icon)`
  background: var(--popup-dialog-close-bg, rgba(33, 33, 33, 0.32));
  border-radius: 50%;
  &:hover,
  &:focus {
    background: rgba(33, 33, 33, 0.22);
  }
`;
